import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import { getAssetsListDataAction, getOverlapAnalysisReportDataAction, GetOverlapAssetsforUniverseAction } from "../../../actions/publicExposureAction";
import { ToastContainer, toast } from "react-toastify";
import { Overlapchart } from "./OverlapChart";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { getUniverseListAction } from "../../../actions/universeListAction";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { SBNotify } from "../../../utils/sbNotify";

export const Overlap = () => {
  const TotalListofAssetApi = useRef();
  const TotalSelectedAssetApi = useRef();
  const [selectedOption, setSelectedRadioOption] = useState("assets");
  const [Value, setValue] = useState([]);
  const [searchAssetValue, setAssetSearchValue] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [OLChartData, setOLChartData] = useState([]);
  const [initailRender,setInitailRender]=useState(true); 
  const dispatch = useDispatch(); 
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
    const UniverseMembers = Gstate.AnalyticsReporting.universeList;
  const chartData = Gstate.PublicExposure.OverlapAnalysisReportData || [];
  const chartDataLoading = Gstate.PublicExposure.OverlapAnalysisLoading;
  const [universe, setUniverse] = useState(UniverseMembers);
    const [selecteduniverse, setselecteduniverse] = useState();
  useEffect(() => {
   
    dispatch(getUniverseListAction());
}, []);
useEffect(()=>{
  setUniverse(UniverseMembers);
}, [Gstate]);
  useEffect(()=>{
    if (initailRender)
     {
      setInitailRender(false);
      return;
    }
    setOLChartData(chartData);
  
  },[chartData]);

    const UniverseListGrid = Gstate.PublicExposure.AssetsforUniverse;
    const assetsListGrid = Gstate.PublicExposure.PublicExposureAssetsList;    
    const assetsListGridRowDataasset = Array.isArray(assetsListGrid)
        ? assetsListGrid.map((row) => {
      const rowDataItem = {
        AssetId: row.AssetId,
        AssetName: row.AssetName,
      };
      return rowDataItem;
    })
        : [];
    const assetsListGridRowDatauniverse = Array.isArray(UniverseListGrid)
        ? UniverseListGrid.map((row) => {
            const rowDataItem = {
                AssetId: row.AssetID,
                AssetName: row.AssetName,
            };
            return rowDataItem;
        })
        : [];
    const assetsListGridRowData = (selectedOption === "assets") ? assetsListGridRowDataasset : assetsListGridRowDatauniverse;
  // Handle radio button change event
    const handleRadioChange = (event) => {
        setSelectedRadioOption(event.target.value);
        // if (event.target.value === "groups") {
        //     setSelectedRows([]);
        // }
  };

  // const handleCheckboxChange = (event) => {
  //   const { checked } = event.target;
  //   setIsChecked(checked);
  //   assetSearchChange(searchAssetValue, checked);
  // };

  const assetSearchValueChange = (event) => {
    const { value } = event.target;
    setAssetSearchValue(value);
    assetSearchChange(value, isChecked);
  };

  const assetSearchChange = async (searchAssetValue, isChecked) => {
    if (searchAssetValue !== "" && searchAssetValue !== null) {
      dispatch(getAssetsListDataAction(searchAssetValue, isChecked));
    }
  };

  // AssetList Column Defs
  const listofAssetsColumnDefs = [
    {
      headerName: "",
      checkboxSelection: true,
      headerCheckboxSelection: false,
      maxWidth: 40,
      resizable: false,
    },
    {
      field: "AssetId",
      headerName: "AssetId",
      hide: true,
    },
    {
      field: "AssetName",
      headerName: "Asset Name",
    },
  ];

  const selectedAssetsColumnDefs = [
    {
      headerName: "",
      checkboxSelection: true,
      headerCheckboxSelection: false,
      maxWidth: 60,
      resizable: false,
      suppressMenu: true,
      rowDrag: true,
    },
    {
      field: "AssetId",
      headerName: "AssetId",
      hide: true,
    },
    {
      field: "AssetName",
      headerName: "Asset Name",
    },
  ];

  // GroupList Column Defs
  const listofGroupColumnDefs = [
    {
     
      field: "",
      headerName: "",
    },
  ];

  const selectedGroupColumnDefs = [
    {  
      field: "",
      headerName: "",
    },
  ];

  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable:true
  };

  //Add list of assets moved here
    const addButtonClick = (e) => {
    const assetList=TotalListofAssetApi.current.api.getSelectedRows();
    if(assetList.length<1)
    {
      SBNotify({Msg:'Please Select any Asset to Add',type:'error'});
    }
        
    else if(assetList.length>0)
    {
      let RepeatedAsset = [];
      assetList.map((item)=>{
        const newAsset = item;
        const assetName=item.AssetName;
        const allAssets = selectedRows.flat();
        if (allAssets.some((asset) => asset.AssetId === newAsset.AssetId)) {
          RepeatedAsset.push(`${assetName}`);
        } 
        else {
          newAsset && addSelectedAsset(newAsset);
        }
      })
      if(RepeatedAsset.length>0)
      {
        let ErrorString="";
          RepeatedAsset.map((item, i) => {
            ErrorString = `${ErrorString}  ${item} ,  `;
          });
        SBNotify({Msg:`${ErrorString} Already Exists`,type:'error'});
      }
  }
  };

  const addSelectedAsset = (newAsset) => {
    const toAdd = {
      AssetId: newAsset.AssetId,
      AssetName: newAsset.AssetName,
    };
    setSelectedRows((pv) => {
      return [...pv, { ...toAdd }];
    });
  };

  //Remove Selected assets
  const removeButtonClick = (e) => {
    const assetList = TotalSelectedAssetApi.current.api.getSelectedRows();
    if(assetList.length===0)
    {
      SBNotify({Msg:"Please Select any Asset to remove",type:'error'});
    }
    else if(assetList.length>0)
    {
      assetList.map(item=>{
        removeSelectedAssets(item);
      })
    }
  };

  const removeSelectedAssets = (selected) => {
    setSelectedRows((pv) =>
      pv
        .filter((item) => item.AssetId !== selected.AssetId)
        .map((item) => {
          return { ...item };
        })
    );
  };

  //Enter to generate chart
    const enterButtonClick = (e) => {
    const assetIds = selectedRows?.map((item) => {
      return item.AssetId
    })
        if (assetIds.length >= 2) {
            dispatch(getOverlapAnalysisReportDataAction(assetIds));
        }
        else {
            SBNotify({Msg:"Please Select any two Assets to Add",type:'error'});
            setOLChartData([]);
        }
   
  };
  const SelAssetDoubleclick=(e)=>{
    removeSelectedAssets(e.data);
  }
  const handleRowDragEnd = (params) => { 
    const rows = [];
    TotalSelectedAssetApi.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    setSelectedRows(rows);
};
    const AvaAssetDoubleclick = (e) => {
    const newAsset = e.data;
        const assetName=newAsset.AssetName;
        const allAssets = selectedRows.flat();
        if (allAssets.some((asset) => asset.AssetId === newAsset.AssetId)) {
          SBNotify({Msg:`${assetName} Already Exists`,type:'error'});
        } 
        else {
          addSelectedAsset(newAsset);
        }
  }
  const resetState=()=>{
    setSelectedRows([]);
    setOLChartData([]);
  }

    const universeListDDChanged = (e) => {
       setselecteduniverse(e.value);
        dispatch(GetOverlapAssetsforUniverseAction(e.value.UniverseEntityMasterId));

}
  return (
    <>
        <div className="row flex-wrap">
          <div className="col-md-12">
            <label
              htmlFor="table-options"
              className="mb-1 ms-2 fw-semibold fs-12"
            >
              Select
            </label>
            <div className="d-flex align-items-center">
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="table-options"
                  id="assets"
                  value="assets"
                  checked={selectedOption === "assets"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="assets" className="form-check-label">
                  Assets
                </label>
              </div>
              <div className="form-check ms-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="table-options"
                  id="groups"
                  value="groups"
                  checked={selectedOption === "groups"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="groups" className="form-check-label">
                  Universe
                </label>
              </div>
            </div>
            <br></br>
            <div className="row align-items-center">
            {selectedOption === "assets" && (  <div className="col-md-4">
                <label className="mb-1 ms-2 fw-semibold fs-12">
                  Select Assets
                </label>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    value={searchAssetValue}
                    onChange={assetSearchValueChange}
                    placeholder="Search Assets..."
                  />
                </div>
              </div>
            )}
              {selectedOption === "groups" && ( <div className="col-md-4">
                <label className="mb-1 ms-2 fw-semibold fs-12">
                  Select Universe
                </label>
                <div>
                              <SBAComboBox data={universe} value={selecteduniverse} textField={'UniverseName'} valueField={"UniverseEntityMasterId"} onChange={universeListDDChanged} filterable={true}/>
                  {/* <input
                    type="text"
                    className="form-control"
                    value={universe}
                    onChange={assetSearchValueChange}
                    placeholder="Search Universe..."
                  /> */}
                </div>
              </div>
)}

              {/* <div className="col-md-4">
                <label></label>
                <div>
                  <label className="ms-2 mt-2">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onClick={handleCheckboxChange}
                    />
                    <span style={{ marginLeft: '10px' }}>Search using contains </span>
                  </label>
                </div>
              </div> */}
            </div>
          </div>
          
            <div id="AssetSetting" className="container-fluid px-3">
              <div className="headingGroup d-flex flex-column">
                <div className="lineDiv">
                  <label id="WarningLabel"></label>
                </div>
                <div></div>
              </div>
              <div className="gridcontent d-flex flex-row mt-3">
                <div className="gridDiv">
                  <div>List of Assets</div>
                  <div
                    className="griddata ag-theme-alpine"
                    style={{ height: "20rem" }}
                  >
                    <AgGridReact
                      columnDefs={listofAssetsColumnDefs}
                      rowData={assetsListGridRowData}
                      defaultColDef={defaultColDef}
                      rowSelection={"multiple"}
                      ref={TotalListofAssetApi}
                      onRowDoubleClicked={AvaAssetDoubleclick}
                    ></AgGridReact>
                  </div>
                </div>
                <div className="d-flex flex-column justify-content-center px-3">
                  <button className="p-sm-btn my-1" onClick={addButtonClick}>
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                  <button className="p-sm-btn my-1" onClick={removeButtonClick}>
                    <i class="fa-solid fa-arrow-left"></i>
                  </button>
                </div>
                <div className="gridDiv">
                  <div>Selected Assets</div>
                  <div
                    className="griddata ag-theme-alpine"
                    style={{ height: "20rem" }}
                  >
                    <AgGridReact
                      columnDefs={selectedAssetsColumnDefs}
                      rowData={selectedRows}
                      defaultColDef={defaultColDef}
                      ref={TotalSelectedAssetApi}
                      rowSelection="multiple"
                      rowDragManaged={true}
                      suppressMoveWhenRowDragging={true}
                      onRowDoubleClicked={SelAssetDoubleclick}
                      onRowDragEnd={handleRowDragEnd}
                    ></AgGridReact>
                  </div>
                </div>
              </div>
            </div>
        


          <div className="mt-3">
            <button type="button" className="cancel-btn" onClick={resetState}>
              Clear All
            </button>
            <button type="button" className="enter-btn ms-2" onClick={enterButtonClick}>
              Enter
            </button>
          </div>
        </div>
          {chartDataLoading ? <><LoadingScreen/></>:<>
          <Overlapchart data={OLChartData} />
          </>
          }
      <ToastContainer></ToastContainer>
    </>
  );
};
